import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Marginer } from "../../Components/Marginer";
import Logo from "../../Assets/Hnet.com-image.png";
import Backpanel from "../../Assets/Background.gif";
import Flowers from "../../Assets/flowers.jpg";
import {Facebook,Instagram,Twitter,Telegram,Linkedin} from "@styled-icons/boxicons-logos";
import {Link} from "react-scroll";
import { BlogComp } from "../../Components/Blog";
import axios from "axios";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useLocation,useNavigate, useParams } from "react-router-dom";
import {Hourglass} from "react-loader-spinner"

const PageHolder = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const HeaderDiv = styled.div`
    width: 100%;
    height: 21vh;
    display: flex;
    flex-direction: column;
    background-color: #443C54;
    align-items: center;

    @media (max-width: 900px) {
        justify-content:center;
    }
`;

const Logoimg = styled.img`
    width: 190px;
    height: auto;
    margin-top: 1.8vw;

    @media (max-width: 900px) {
        margin-top: 5px;
    }

    &:hover{
        cursor:pointer;
    }

`;


const BottomLine = styled.div`
    width: 70vw;
    height: 1px;
    margin-top: 0.9vw;
    background-color: #ffffff6a;
    border-radius: 80%;
    box-shadow: 0px 2px 7px 2px #353535;

    @media (max-width: 900px) {
        width: 90vw;
        margin-top: 3vw;
    }

`;

const Linkholder = styled.div`
    width: 60vw;
    height: 3vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    @media (max-width: 900px) {
        width: 90vw;
    }

    @media (min-width: 900px) and (max-width: 1400px) {
        width: 70vw;
    }

`;


const SocialHolder = styled.div`
    width: 20vw;
    height: 3vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;



    @media (max-width: 600px) {
       
       width: 0vw;
       display: none;
    }

    @media (min-width: 600px) and (max-width: 900px) {
        
        width: 22vw;
    }

   

`;

const Facebooklink = styled(Facebook)`
  width: 1.2vw;
  color:${props => props.color};


  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }

`;

const Instagramlink = styled(Instagram)`
  width: 1.2vw;
  color:${props => props.color};


  &:hover{
        cursor: pointer;
        color: #e2d186;
    }
    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }
  
`;

const Twitterlink = styled(Twitter)`
  width: 1.2vw;
  color:${props => props.color};
  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }

`;

const Telegramlink = styled(Telegram)`
  width: 1.2vw;
  color:${props => props.color};


  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }

`;

const Linkedinlink = styled(Linkedin)`
  width: 1.2vw;
  color: ${props => props.color};

  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
        width: 3vw;
   }

   @media (min-width: 450px) and (max-width: 900px) {
       
        width: 2vw;
   }

   @media (min-width: 900px) and (max-width: 1300px) {
       
        width: 1.7vw;
   }

   @media (min-width: 1300px) and (max-width: 1700px) {
       
    width: 1.2vw;
   }

    

`;

const Numbertext = styled.h3`
    font-size: 0.8vw;
    color: white;
    font-weight: normal;
    margin-top: 9px ;

    @media (max-width: 600px) {
       
        font-size: 1.8vw;
    }

    @media (min-width: 600px) and (max-width: 900px) {
        
        font-size: 1.6vw;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        
        font-size: 1.2vw;
    }

    @media (min-width: 1300px) and (max-width: 1700px) {
        
        font-size: 0.9vw;
    }

  
  
`;

const LinkButton = styled.button`
    width:7vw;
    height:1.5vw;
    background-color: #443C54 ;
    border:0px;
    color: white;
    font-size: 1.1vw;

    &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 600px) {
        width: 19vw;
        font-size: 3.4vw;
        font-weight: bold;
    }

    @media (min-width: 600px) and (max-width: 900px) {
        width: 16vw;
        font-size: 2.4vw;
        font-weight: bold;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        width: 10vw;
        font-size: 1.7vw;
    }

    @media (min-width: 1300px) and (max-width: 1700px) {
        width: 9vw;
        font-size: 1.2vw;
    }

  
`;

const Mainpanel = styled.div`
  width:100%;
  min-height: 80vh;
  background-image: url(${Flowers});
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  object-fit: contain;
`;

const MainpanelCover = styled.div`
  width: 100%;
  min-height: 80vh;
  background-color: #000000a0;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: flex-start;
`;

const CoverImage = styled.img`
  border: solid 4px #443C54;
  align-self: center;
  max-width: 80%;

`;

const BlogArea = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  overflow-x: hidden;
`;

const ViewerArea = styled.div`
  width: 60%;
  min-height: 80%;
  background-color: #ffffff;
  border: solid 4px #443C54;
  padding: 20px;
  margin-top: 40px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items:center;
  @media (max-width: 600px) {
       
    width: 80%;
     }
`;

const ViewerPostArea = styled.div`
  width: 100%;
  min-height: 80%;
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 40px;
`;

const BlogText = styled.p`
 font-size: 2vw;
 font-weight: bold;
 color: #000000;
 margin: 40px;
 align-self: center;
 margin-top: 10px;
 text-align: center;

 @media (max-width: 450px) {
       
    font-size: 4.3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
    font-size: 3.6vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
    font-size: 2.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
    font-size: 2.2vw;
  }

`;

export function ViewBlogPage(props){
    let location = useLocation();
    const [loading, setLoading] = useState(false)
    const [blog, setBlog] = useState({})
    const { id } = useParams();

    useEffect(() => {
        if(location.state){
        }else{
            setLoading(true)
            axios.get('https://salwa-amer-backend.onrender.com/get_blogs')
            .then(res => {
                const blogslist = res.data;
                console.log(id)
                let found = blogslist.find(function (element) {
                    return element._id === id;
                });
                 
                console.log(found)
                setBlog(found)
                setLoading(false)
            })
        } 
    },[])

    const navigate = useNavigate();
    return(
        <PageHolder>
            <HeaderDiv>
            <Logoimg onClick={()=>{navigate("/")}} src = {Logo} ></Logoimg>
            <BottomLine/>
            <Marginer height={2} width ={1}></Marginer>
            <Linkholder>
            <SocialHolder>
            <Numbertext> +966563674328 </Numbertext>
            </SocialHolder>
            <LinkButton onClick={()=>{navigate("/")}}> من أنا</LinkButton>
            <LinkButton onClick={()=>{navigate("/")}}> تواصل معي </LinkButton>
            {/* <LinkButton>دورات</LinkButton> */}
            <LinkButton onClick={()=>navigate("/blogs")}>منشورات</LinkButton>
            <LinkButton onClick={()=>{navigate("/")}}>استشارات</LinkButton>
            <LinkButton onClick={()=>{navigate("/")}}>الرئيسية</LinkButton>
            <SocialHolder>
            <a href={"https://www.facebook.com/salwaamer2020"}  target={"blank"}><Facebooklink color={"white"}></Facebooklink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://www.instagram.com/sa.lwa4494/"}  target={"blank"}><Instagramlink color={"white"}></Instagramlink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://twitter.com/Hadfona_wahd"}  target={"blank"}><Twitterlink color={"white"}></Twitterlink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://t.me/alacademya"}  target={"blank"}><Telegramlink color={"white"}></Telegramlink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://www.linkedin.com/in/salwa-amer-71629b156/"}  target={"blank"}><Linkedinlink color={"white"}></Linkedinlink></a>
            <Marginer height={0} width ={2}></Marginer>
            </SocialHolder>
            </Linkholder>
            </HeaderDiv>
            <Mainpanel>
                <MainpanelCover>
                    <BlogArea>

                    {loading === true?<Hourglass
                                                        visible={true}
                                                        height="80"
                                                        width="80"
                                                        ariaLabel="hourglass-loading"
                                                        wrapperStyle={{"margin":"25px"}}
                                                        wrapperClass=""
                                                        colors={['#ffffff', '#ffffff']}
                                                        />:
                                                        <>
                    <ViewerArea>
                        <BlogText>{location.state? location.state.title: blog.title}</BlogText>
                        <CoverImage src={location.state? location.state.image: blog.image}></CoverImage>
                    <ViewerPostArea>
                    <ReactQuill
                        value={location.state? location.state.content: blog.content}
                        readOnly={true}
                        theme={"bubble"}
                        />
                    </ViewerPostArea>
                    </ViewerArea>
                    </>}
                    </BlogArea>
                </MainpanelCover>
            </Mainpanel>
        </PageHolder>
    );
}